import React, { useState, useEffect } from 'react';
import moment from 'moment';
import './MonitorCliente.css';
import logoCampos from '../images/logoCampos.png';


const MonitorCliente = () => {
  const [despachos, setDespachos] = useState([]);
  const [error, setError] = useState(null);
  const [isFullscreenMode, setIsFullscreenMode] = useState(false);

  // Toggle de pantalla completa del navegador usando Fullscreen API
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        setIsFullscreenMode(true);
      }).catch(err => {
        console.error("Error al activar pantalla completa:", err);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().then(() => {
          setIsFullscreenMode(false);
        });
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreenMode(!!document.fullscreenElement);
    };
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  // Función para obtener los datos
  const fetchMonitorData = async () => {
    try {
      const response = await fetch('/api/despacho/monitor', {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      if (data.ok) {
        setDespachos(data.despachos || []);
        setError(null);
      } else {
        setError(data.message || 'Error al obtener despachos.');
      }
    } catch (err) {
      console.error('Error fetching monitor data:', err);
      setError('Problema de red.');
    }
  };

  useEffect(() => {
    // Primera carga
    fetchMonitorData();
    // Polling cada 10 segundos
    const intervalId = setInterval(fetchMonitorData, 10000);
    return () => clearInterval(intervalId);
  }, []);

  // Helpers de filtrado
  const pendientes = despachos.filter(d => d.Estado === 'PENDIENTE');
  const enProceso = despachos.filter(d => d.Estado === 'EN_PROCESO');

  // Separar DESPACHADO en 'LISTO' y 'RECIENTES' usando FechaActualizacion (< 5 min es LISTO)
  const despachados = despachos.filter(d => d.Estado === 'DESPACHADO');
  const listos = [];
  const recientes = [];

  despachados.forEach(d => {
    // Usamos el cálculo seguro desde el servidor (MySQL NOW()) para evitar bugs de zona horaria
    const minsDesdeActualizacion = d.MinutosDesdeActualizacion || 0;
    if (minsDesdeActualizacion < 2) {
      listos.push(d);
    } else {
      recientes.push(d);
    }
  });

  listos.sort((a, b) => Number(b.IdDespacho) - Number(a.IdDespacho));

  return (
    <div className="monitor-cliente-container">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <div className="d-flex align-items-center">
          <a href="/" className="btn btn-light btn-sm rounded-circle mr-3" title="Volver al panel" style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #ccc' }}>
            <i className="fas fa-arrow-left"></i>
          </a>
        </div>
        <div className="d-flex align-items-center">
          <h2 className="monitor-header-title m-0">
            REVISA TU PEDIDO
          </h2>
        </div>
        <button
          className="btn btn-sm px-3 font-weight-bold shadow-sm"
          style={{
            backgroundColor: isFullscreenMode ? '#ecf0f1' : '#008080',
            color: isFullscreenMode ? '#2c3e50' : '#ffffff',
            border: 'none',
            borderRadius: '20px',
            transition: 'all 0.2s ease',
            cursor: 'pointer'
          }}
          onClick={toggleFullscreen}
        >
          <i className={`fas ${isFullscreenMode ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt'} mr-2`}></i>
          {isFullscreenMode ? 'Salir de Pantalla Completa' : 'Pantalla Completa'}
        </button>
      </div>

      {error && <div className="error-banner">{error}</div>}

      <div className="kanban-grid">

        {/* COLUMNA 2: EN PROCESO */}
        <div className="kanban-column">
          <div className="kanban-column-header">
            <h3 style={{ fontSize: '30px' }}>EN PREPARACIÓN</h3>
          </div>
          <div className="kanban-cards-container">
            {enProceso.map(item => (
              <div key={item.IdDespacho} className="kanban-card card-proceso">
                <div className="kanban-card-title">
                  {parseInt(item.NumeroComprobante, 10)}
                </div>
                <div className="kanban-card-body">
                  <p><strong>{item.Alias || 'VARIOS'}</strong></p>
                  <p style={{ fontSize: '16px' }}>Atendido por:  <strong style={{ fontSize: '30px' }}>{(item.OperarioNombre || 'VARIOS').toUpperCase()}</strong></p>
                </div>
              </div>
            ))}
            {enProceso.length === 0 && <div className="text-muted text-center mt-2">Nada en proceso</div>}
          </div>
        </div>

        {/* COLUMNA 3: LISTO PARA RECOGER */}
        <div className="kanban-column">
          <div className="kanban-column-header">
            <h3 style={{ fontSize: '30px' }}>LISTO PARA RECOGER</h3>
          </div>
          <div className="kanban-cards-container">
            {listos.map(item => (
              <div key={item.IdDespacho} className="kanban-card card-listo">
                <div className="kanban-card-title">
                  {parseInt(item.NumeroComprobante, 10)}
                </div>
                <div className="kanban-card-body">
                  <p><strong>{item.Alias || 'VARIOS'}</strong></p>
                  {/* <p style={{ fontSize: '10x' }}>Atendido por: <strong style={{ fontSize: '30px' }}>{item.OperarioNombre || 'VARIOS'}</strong></p> */}
                </div>
              </div>
            ))}
            {listos.length === 0 && <div className="text-muted text-center mt-2">No hay listos para recoger</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MonitorCliente;
